import React from 'react';
import AvatarName from '../../shared/AvatarName';

interface DriverProps {
  driverName?: string;
  avatarSize?: 'default' | 'small' | 'large';
  deleted: boolean;
}

const DriverProfile: React.FC<DriverProps> = React.memo(({ driverName, avatarSize = 'default', deleted = false }) => {
  return (
    <AvatarName
      name={driverName}
      avatarSize={avatarSize}
      deleted={deleted}
      testId={`driver-profile${deleted ? '-deleted' : ''}-${driverName}`}
    />
  );
});

DriverProfile.displayName = 'DriverProfile';

export default DriverProfile;
